import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
var n = {
	content: "",
	group: "block",
	attrs: t({
		type: { default: "spacer" },
		height: { default: 20 }
	}),
	toDOM(t) {
		return ["div", { class: `${e.blockContainer} ${e.spacer} intercom-spacer-container` }];
	}
};
//#endregion
export { n as spacerSpec };
